
export function setLoading(state, loading) {
    state.loading = loading
}
export function PharexReport(state, pharex_report){
    state.pharex_report = pharex_report
}




// WEBPACK FOOTER //
// ./src/modules/report-pharex/mutations.js